import React, { Component } from 'react'
import { connect } from 'react-redux'
import  ShoppingCart  from '../../../images/ShoppingCart.png'
import '../../../styles/checkout/mainStyle.css'
import {  toggleDisplayIframe, setShowCalllback, setNotShowCalllback } from '../../../actions/checkoutActions'
import CallBack from './CallBack'

export class CheckoutPage extends Component {
    render() {
        return (
            <div style={{display: this.props.ifDisplayIframe ? 'none' : 'inline', height: '100%'}}>
                <div className="merChantBox2">
                    <div className="merChantTitleBar2">
                        <div className="merChantTitleText2">The merchant’s checkout page</div>
                    </div>
                    <img className='shoppingCart2' src={ShoppingCart} alt="Logo" />
                    {/* <div className="insertContext">I want to insert here my Moneris Checkout instance</div> */}
                </div>
                <CallBack/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { PreoloadPrequestResponse, ifDisplayIframe, ifShowCallbackConsole,callBackConsole } = state.checkout.main;
    return { PreoloadPrequestResponse, ifDisplayIframe, ifShowCallbackConsole,callBackConsole };
}

export default connect(mapStateToProps, {  toggleDisplayIframe, setShowCalllback, setNotShowCalllback  })(CheckoutPage)
